module.exports = __webpack_public_path__ + "img/meeting-time.da998a4c.svg";